import { useEffect, useState, useRef } from "react";
import { initiateMic } from "../utils/sys_utils";

window.stream = null;

export const useAudioRecorder = ({ isRecording }) => {
  const [err, setErr] = useState(null);
  const [data, setData] = useState(null);
  let recorder = useRef(null);
  const stream = useRef(null);

  function clearMediaStream() {
    if (stream.current) {
      stream.current.getTracks().forEach((track) => track.stop());
      stream.current = null;
    }
  }
  useEffect(() => {
    return () => {
      if (window.stream) {
        removeTracks(window.stream);
      }
    };
  }, []);

  useEffect(() => {
    //getUserMedia(constraints, setStream, setErr)
    initiateMic()
      .then((streams) => (stream.current = streams))
      .catch((err) => setErr(err));
    // console.log("stream for recorder", stream.current);
  }, [isRecording]);

  useEffect(() => {
    if (isRecording) {
      if (!MediaRecorder && stream.current instanceof MediaStream) {
        setErr("Unsupported browser");
      } else if (stream.current instanceof MediaStream) {
        setData(null);
        let chunks = [];
        console.log("this is recording");
        const mediaRecorder = new MediaRecorder(stream.current);
        mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
        mediaRecorder.onerror = (e) => setErr(getRecorderError(e.error));
        mediaRecorder.onstop = () => {
          console.log("the recording has stopped");
          setData(chunks);
        };
        mediaRecorder.start(10);
        recorder.current = mediaRecorder;
      }
    } else if (recorder.current && recorder.current.state === "recording") {
      recorder.current.stop();
      //clearMediaStream();
    }
  }, [isRecording, stream]);

  return [data, err];
};

function getRecorderError(error) {
  let errMessage = null;
  switch (error.name) {
    case "InvalidStateError":
      errMessage = "An error occurred while recording. Try again later.";
      break;
    case "SecurityError":
      errMessage = "Recording is not allowed due to security restrictions.";
      break;
    default:
      errMessage = "An error occurred while recording. Try again later.";
      break;
  }

  return errMessage;
}

function getTracks(stream) {
  return stream.getTracks();
}

function removeTrack(stream, track) {
  track.stop();
  stream.removeTrack(track);
}

function removeTracks(stream) {
  try {
    const tracks = getTracks(stream);
    if (tracks && tracks.length > 0) {
      tracks.forEach((track) => {
        removeTrack(stream, track);
      });
    }
  } catch (err) {
    /* eslint-disable */
    console.error(`Error while removing tracks: ${err.message}`);
    /* eslint-enable */
  }
}
